import clsx from 'clsx'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { getGenderTitle } from 'type/gender'
import css from './GenderButton.module.scss'

type Props = {
  gender: string
}

export const GenderButton = observer(({ gender }: Props) => {
  const demo = useDemo()
  const { form } = demo
  const active = form.gender === gender
  const className = clsx(css.button, active && css.active)

  const onClick = useLatestCallback(() => {
    form.gender = gender
  })

  return <Space className={className} center onClick={onClick}>
    <Typo size={16} accent medium>
      {getGenderTitle(gender)}
    </Typo>
  </Space>
})
